export const flattenObjectToArray = (ob) => {
  const toReturn = [];

  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue;

    if ((typeof ob[i]) == 'object') {
      const flatObject = flattenObjectToArray(ob[i]);
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn.push(flatObject[x]);
      }
    } else {
      toReturn.push(ob[i]);
    }
  }
  return toReturn;
};

export const getRandomHexColor = () => {
  const colors = [
    Math.floor(Math.random() * 255),
    Math.floor(Math.random() * 255),
    Math.floor(Math.random() * 255)
  ];
  return (colors[0] << 16) + (colors[1] << 8) + colors[2];
};


// WEBPACK FOOTER //
// ./src/lib/helpers.js